import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./MobileCoinAllotmentOverlay.css";
import axios from "axios";
import { Api } from "../../BackendApi/api";
import MobileConfirmPopup from "../../Component/MobileConfirmPopup/MobileConfirmPopup";
import MobileCustomerOverlay from "../MobileCustomer/MobileCustomerOverlay";

let typingTimer;

const MobileCoinAllotmentOverlay = ({ onClose, onSave, customer }) => {
  const [formData, setFormData] = useState({
    customer: "",
    customerId: "",
    dateTime: new Date(),
    transactionNo: "",
    coins: "",
    remarks: "",
    billInfo: "",
  });

  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [popup, setPopup] = useState({
    show: false,
    message: "",
    type: "success",
  });

  const [showCustomerOverlay, setShowCustomerOverlay] = useState(false);
  const coinallotRef = useRef(null);

  useEffect(() => {
    if (customer) {
      setFormData((prev) => ({
        ...prev,
        customer: customer.name || "",
        customerId: customer.id || "",
      }));
    }
  }, [customer]);

  useEffect(() => {
    if (coinallotRef.current) {
      coinallotRef.current.focus();
    }
  }, []);

  const fetchCustomers = async (search) => {
    if (!search.trim()) {
      setCustomers([]);
      return;
    }
    setLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.post(
        `${Api.baseurl}/getcustomers`,
        {
          searchstring: search,
          startfrom: 0,
          limit: 50,
          SortColumn: "CreatedAt",
          SortOrder: -1,
          Status: "ACTIVE",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const customerArray = response.data.data || response.data.customers || [];
      const list = customerArray.map((item) => ({
        id: item._id,
        name: item.CustName || "N/A",
        mobile: item.CustMobile || "N/A",
        coins: item.CustCurrentCoins != null ? item.CustCurrentCoins : 0,
      }));

      setCustomers(list);
      setShowDropdown(true);
    } catch (err) {
      console.error("Error fetching customers:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleCustomerInput = (e) => {
    const value = e.target.value;
    setFormData({
      ...formData,
      customer: value,
    });

    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      fetchCustomers(value);
    }, 500);
  };

  const handleSelectCustomer = (cust) => {
    setFormData({
      ...formData,
      customer: cust.name,
      customerId: cust.id,
    });
    setCustomers([]);
    setShowDropdown(false);
  };

  const handleDateChange = (date) => {
    setFormData({
      ...formData,
      dateTime: date,
    });
  };


  const submitTransaction = async (type) => {
    if (!formData.customer || !formData.coins) {
      setPopup({
        show: true,
        message: "Please select a customer and enter coins.",
        type: "warning",
      });
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("authToken");

      const transDateISO = formData.dateTime
        ? new Date(formData.dateTime).toISOString()
        : new Date().toISOString();
      const entryDateISO = new Date().toISOString();

      const payload = {
        CustName: formData.customer,
        CustId: formData.customerId,
        TransValue: Number(formData.coins),
        TransType: type,
        TransDesc: formData.remarks || "Coins Transaction",
        TransactionNo: formData.transactionNo || "",
        BillInfo: formData.billInfo || "",
        TransDate: transDateISO,
        CreatedAt: entryDateISO,
      };


      const response = await axios.post(Api.coinAllotment, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.success || response.data.status === 1) {
        setPopup({
          show: true,
          message: `Coins ${type === "ALLOT" ? "Allotted" : "Deducted"
            } Successfully`,
          type: "success",
        });
      } else {
        setPopup({
          show: true,
          message: response.data.message || "Transaction failed",
          type: "error",
        });
      }
    } catch (err) {
      console.error(err);
      setPopup({
        show: true,
        message: "Something went wrong. Please check your network.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleAllot = (e) => {
    e.preventDefault();
    submitTransaction("ALLOT");
  };

  const handleDeduct = (e) => {
    e.preventDefault();
    submitTransaction("DEDUCT");
  };

  const handlePopupClose = () => {
    setPopup({ ...popup, show: false });
    if (popup.type === "success") {
      if (onSave) onSave();
      onClose();
    }
  };

  const handleCustomerSave = () => {
    setShowCustomerOverlay(false);
    fetchCustomers(formData.customer || "");
  };

  return (
    <div className="mobile-coinallot-overlay">
      <div className="mobile-coinallot-overlay-content">
        <h2>Coin Allotment</h2>

        {customer && (
          <div className="customer-info-box">

          </div>
        )}

        <form className="mobile-coinallot-overlay-form">
          <label>
            Customer
            <div
              className="mobile-customer-field"
              style={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <input
                type="text"
                name="customer"
                value={formData.customer}
                onChange={handleCustomerInput}
                ref={coinallotRef}
                onFocus={() => formData.customer && setShowDropdown(true)}
              />
              <button
                type="button"
                className="mobile-add-customer-btn"
                onClick={() => setShowCustomerOverlay(true)}
                title="Add New Customer"
              >
                +
              </button>

              {showDropdown && customers.length > 0 && (
                <div className="mobile-customer-dropdown">
                  {loading ? (
                    <div className="mobile-customer-option">Searching...</div>
                  ) : (
                    customers.map((cust) => (
                      <div
                        key={cust.id}
                        className="mobile-customer-option"
                        onClick={() => handleSelectCustomer(cust)}
                      >
                        {cust.name} - Coins: {cust.coins}
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          </label>

          <label>
            Date & Time
            <DatePicker
              selected={formData.dateTime}
              onChange={handleDateChange}
              showTimeSelect
              dateFormat="dd/MM/yyyy h:mm aa"
              className="mobile-datepicker-input"
            />
          </label>

          <label>
            Bill Info
            <input
              type="text"
              name="billInfo"
              value={formData.billInfo}
              onChange={(e) =>
                setFormData({ ...formData, billInfo: e.target.value })
              }
            />
          </label>

          <label>
            Remarks
            <input
              type="text"
              name="remarks"
              value={formData.remarks}
              onChange={(e) =>
                setFormData({ ...formData, remarks: e.target.value })
              }
            />
          </label>

          <label>
            Coins
            <div className="mobile-coins-input-wrapper">
              <input
                type="text"
                value={formData.coins}
                onChange={(e) =>
                  setFormData({ ...formData, coins: e.target.value })
                }
                placeholder="Enter Coins"
              />
              <span className="mobile-coins-label">Coins</span>
            </div>
          </label>

          <div className="mobile-coinallot-overlay-buttons full-width">
            <button
              type="submit"
              className="mobile-coin-btn-allot"
              onClick={handleAllot}
              disabled={loading}
            >
              <span className="mobile-symbol">+</span> Allot
            </button>
            <button
              type="submit"
              className="mobile-coin-btn-deduct"
              onClick={handleDeduct}
              disabled={loading}
            >
              <span className="mobile-symbol">−</span> Deduct
            </button>
            <button type="button" onClick={onClose} disabled={loading}>
              Cancel
            </button>
          </div>
        </form>
      </div>


      <MobileConfirmPopup
        show={popup.show}
        message={popup.message}
        type={popup.type}
        onClose={handlePopupClose}
      />

      {showCustomerOverlay && (
        <MobileCustomerOverlay
          onClose={() => setShowCustomerOverlay(false)}
          onSave={handleCustomerSave}
        />
      )}
    </div>
  );
};

export default MobileCoinAllotmentOverlay;
